import React from 'react';
import { Building2 as BusinessOutlinedIcon } from 'lucide-react';
import styles from './CustomerDetails.module.scss';

type CustomerDetailsProps = {
    customerName: string;
    /** Acts on the organisation named here; sits inside the box, beside the name. */
    action?: React.ReactNode;
};

const CustomerDetails = ({ customerName, action }: CustomerDetailsProps) => {
    return (
        <div className={styles.customerDetails} data-testid='customer-details'>
            <BusinessOutlinedIcon className={styles.icon} />
            <div className={styles.description}>
                <div className={styles.label}>Organisation</div>
                <div className={styles.name}>{customerName}</div>
            </div>
            {action && <div className={styles.action}>{action}</div>}
        </div>
    );
};

export default CustomerDetails;
